import React from "react";
import { Screens, UI_BuyInsuranceWithCoins, UI_BuyInsuranceWithGems, UI_SwapScreen, playerIdentityStateAtom, shopActionState } from "../framework/UI_State";
import { t } from "../../../shared/data/Data_I18N";
import { useRecoilValue } from "recoil";
import { UserType } from "../../../shared/SharedTypes";

export const ConfirmCoinInsurancePurchase = () => {
    const { shopActionInProgress } = useRecoilValue(shopActionState);
    const { userType, userDetails } = useRecoilValue(playerIdentityStateAtom);

    // @ts-ignore
    const { PVPZ_Currency } = userDetails;
    const { gems, gold } = PVPZ_Currency;

    return (
        <>
            <div className="confirm-skin-panel animate__animated animate__fadeInUp animate__faster">
                <div className="confirm-skin-header">Insurance</div>

                <div className="confirmation" style={{ marginBottom: "20px" }}>
                    {gems < 150 && <>It looks like you don't have enough Gold to purchase insurance credits!</>}
                    {gems >= 150 && (
                        <>
                            Purchasing <span>10 Insurance Credits</span> will cost
                            <br />
                            <span>5000 Gold</span>. Are you sure?
                        </>
                    )}
                </div>

                {userType === UserType.Anonymous && (
                    <>
                        <p className="not-registered">Sorry, only registered accounts can buy things from the store! Create an account and try again!</p>
                    </>
                )}

                {userType === UserType.Registered && (
                    <>
                        <button
                            className="affirmative-button"
                            disabled={gold < 5000 || shopActionInProgress}
                            onClick={() => {
                                UI_BuyInsuranceWithCoins();
                            }}
                        >
                            Buy 10 Credits for 5000 Gold
                        </button>
                    </>
                )}

                <button
                    className="neutral-button"
                    disabled={shopActionInProgress}
                    onClick={() => {
                        UI_SwapScreen(Screens.Shop);
                    }}
                >
                    {t("stats__back_btn")}
                </button>
            </div>
        </>
    );
};
